import {Stack, Typography, Box, Button} from '@mui/material'
import mobileClasses from './mobile.module.css'
import RpIcon from "@/components/RpIcon";
import {useTranslation} from "react-i18next";
import {getUrlParams} from "@/utils/utils";
import React from "react";
import {useNavigate} from "react-router-dom";
import RouteConstant from "@/constant/RouteConstant";
const SuccessPage = () => {
  const source = getUrlParams('source')
  const navigate = useNavigate();
  const { t } = useTranslation()
  return (<>
    <Stack direction="column" alignItems="center" sx={{
      position: 'relative',
      height: '100%',
    }} className={mobileClasses.root}>
      <Stack sx={{
        width: '100%',
        height: '50px',
        padding: '0 16px',
      }} direction="row" alignItems="center" justifyContent="space-between">
        <Box onClick={() => {
          switch (source) {
            case 'buy_card':
              navigate(RouteConstant.MAIN)
              break
            case 'delete_card':
              navigate(RouteConstant.MAIN)
              break
            default:
              navigate(RouteConstant.MAIN)
              break
          }
        }}><RpIcon icon="arrow-left" size={20}/></Box>
      </Stack>
      <Stack direction="column" alignItems="center" gap={'16px'} sx={{marginTop:'64px'}}>
        <RpIcon size={64} icon="check-circle-thin" />
        {source == 'buy_card' && <Stack direction={'column'} gap={'12px'} alignItems={'center'}>
          <p className={'h2'}>{t('success')}</p>
          <Typography>{t('welcome_redotpay')}</Typography>
        </Stack>}
        {source == 'delete_card' && <Stack direction={'column'} gap={'12px'} alignItems={'center'}>
          <p className={'h2'}>{t('delete_card')}{t('success')}</p>
        </Stack>}
        {source == 'reissue_card' && <Stack direction={'column'} gap={'12px'} alignItems={'center'}>
          <p className={'h2'}>{t('success')}</p>
          <Typography>{t('welcome_redotpay')}</Typography>
        </Stack>}
      </Stack>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          padding: '0 16px',
          bottom: '16px'
        }}
      >
        <Button
          size="large"
          variant="contained"
          fullWidth
          onClick={() => {
            navigate('/', {replace: true})
          }}
        >
          {t('got_it')}
        </Button>
      </Box>
    </Stack>
  </>)
}

export default SuccessPage